import { bool } from 'prop-types';

const ConditionalWrapper = ({
  condition,
  wrappingElement,
  children,
}) => (condition ? wrappingElement(children) : children);

ConditionalWrapper.propTypes = {
  condition: bool,
};

ConditionalWrapper.defaultProps = {
  condition: false,
};

export default ConditionalWrapper;
